//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum NotificationSubject {
  /** Отключена синхронизация аккаунта */
  AcountSyncOff = 0,
  /** Отключена синхронизация товаров */
  ProductsSyncOff = 1,
  /** Сброшен матчинг товара */
  MatchingUnset = 2,
  /** Скоро истекает действия API токена истекает */
  ApiTokenWillExpireSoon = 3,
  /** Истекает срок действия подписки MPsklad */
  SubscriptionWillExpireSoon = 4
}
